{
  "title": "チェックインを完了できません",
  "message": "身分証明書を確認できませんでした"
}
